import React, { useState } from "react";
import styles from './styles/login.module.css';
import UploadLogoButton from '../components/UploadLogoButton/UploadLogoButton';
import uploadIcon from '../../src/assests/icons/uploadIcon.png';
import submitIcon from '../../src/assests/icons/submitIcon.png';
import UploadLogoButtonAll from "../components/UploadLogoButton/UploadLogoButtonAll";
import { useNavigate } from "react-router-dom";
import upwardarrow from "../assests/Upwardarrow/upwardArrow.svg";




function LogoUpload() {
  const [submitted,setSubmitted] = useState(null);
  const navigator = useNavigate();

  // Callback function to receive data from the child
  // const handleChildData = (data) => {
  //   setChildData(data);
  // };
  return (
    <div className={styles.login}>
        <h1 className="mb-6">Upload your logo here</h1>
        <p>All we need is your logo (a PNG is preferred for the best visual result), but a JPG is fine too.</p>
        <p>Upload your logo by clicking on icon below</p>
        {/* <p>or click here to browse:</p> */}
        {/* <div className="mt-4 w-16 h-16 rounded-full bg-blue-400 p-1 cursor-pointer">
          <img src={uploadIcon} alt='uploadIcon' />
        </div> */}
        <UploadLogoButtonAll
        btnID={"all"}
        submitted={submitted}
        setSubmitted={setSubmitted}
        />
        <div style={{ fontFamily: "ZapfHumanistBold" }}>
          UPLOAD LOGO
        </div>
        <div onClick={()=>navigator("/home",{ state: submitted })} className="bg-gradient-to-b from-black to-black px-3 py-[2px] cursor-pointer rounded-[40px] mt-4 flex gap-6 justify-center items-center text-white transition-transform duration-300 hover:scale-110">
          <p className="mr-[-10px]" style={{ fontFamily: "ZapfHumanistBold" }}>SUBMIT</p>
          {/* <img className="w-8 mr-[-10px]" src={submitIcon} alt='uploadIcon' /> */}
          <div className="rounded-full h-7 w-7 bg-white flex justify-center p-1 cursor-pointer mr-[-10px]  transform rotate-90">
          <img
              className="w-4 h-4 mt-1 cursor-pointer"
              src={upwardarrow}
              alt="Upward Arrow"
          />
          </div>
        </div>
        {/* <UploadLogoButton
            text={"UPLOAD LOGO"}
            style={"gap-[16px] my-5 w-[224px]"}
            btnID={"all"}
          /> */}
    </div>
  ); 
}

export default LogoUpload;
